import FBSyncBase from "./framework/FBSyncBase";
import {SimSkillOrder} from "./calculation/SkillOrder";
import {ChampionRunes, SimRunes} from "./calculation/CalculationObjects";

import {SimStats} from "./calculation/SimStats";

export interface UIItemAdded{
	deleteId:number;
	itemName:string;
	level:number;
}

export default class Player extends FBSyncBase{
	selectedChampion:string;
	selectedSkillOrder:SimSkillOrder;
	selectedRunes:ChampionRunes;
	selectedItems:UIItemAdded[] = [];


	addItem(itemName, level){
		this.selectedItems.push({itemName, level, deleteId:Math.floor(Math.random()*1000000)})
	}

	removeItem(item:UIItemAdded){
		for (let i = 0; i < this.selectedItems.length; i++) {
			let selectedItem = this.selectedItems[i];
			if (selectedItem.deleteId == item.deleteId){
				this.selectedItems.splice(i, 1);
				return;
			}
		}
	}
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/fbobjects/Player.ts